export enum FormField {
  ID = 'id',
  DOSAGE_DATE = 'dosageDate',
  DOSAGE_TIME = 'dosageTime',
  ADMINISTERED_DATE = 'administeredDate',
  ADMINISTERED_TIME = 'administeredTime',
  ADMINISTERED_TIME_OFFSET = 'administeredTimeOffset',
  COMMENTS = 'comments',
  FIRST_INITIAL = 'firstInitial',
  LAST_INITIAL = 'lastInitial',
  FIRST_INITIAL_SIGN2 = 'firstInitial_sign2',
  LAST_INITIAL_SIGN2 = 'lastInitial_sign2',
  SLOW_RELEASE = 'slowRelease',
  WARFARIN = 'warfarin',
  MARK_ALL_THAT_APPLY = 'markAllThatApply',
  INR = 'inr',
  HOLD_DATE = 'holdDate',
  HOLD_TIME = 'holdTime',
  HOLD_TIME_OFFSET = 'holdTimeOffset',
  HOLD_FIRST_INITIAL = 'holdFirstInitial',
  HOLD_LAST_INITIAL = 'holdLastInitial',
  HOLD_COMMENTS = 'holdComments',
  IS_HOLD = 'isHold',
  IS_HELD = 'isHeld',
  DISCONTINUE_DATE = 'discontinueDate',
  DISCONTINUE_TIME = 'discontinueTime',
  DISCONTINUE_TIME_OFFSET = 'discontinueTimeOffset',
  DISCONTINUE_FIRST_INITIAL = 'discontinueFirstInitial',
  DISCONTINUE_LAST_INITIAL = 'discontinueLastInitial',
  DISCONTINUE_COMMENTS = 'discontinueComments',
  IS_DISCONTINUED = 'isDiscontinued'
}

export enum FormFieldLabel {
  DOSAGE_DATE = 'Dosage Date',
  DOSAGE_TIME = 'Dosage Time',
  ADMINISTERED_DATE = 'Administered Date',
  ADMINISTERED_TIME = 'Administered Time',
  MARK_ALL_THAT_APPLY = 'Mark All That Apply',
  OTHER_CONSIDERATIONS = 'Other Considerations',
  INR = 'INR',
  ADMINISTERED_TIME_OFFSET = 'Administered Time Offset',
  COMMENTS = 'Comments (Administration Notes, Dose Given, etc.)',
  FIRST_INITIAL = 'First Initial',
  LAST_INITIAL = 'Last Initial',
  HOLD_DATE = 'Hold Date',
  HOLD_TIME = 'Hold Time',
  HOLD_TIME_OFFSET = 'Hold Time Offset',
  HOLD_COMMENTS = 'Comments (Reason for hold, Notes, etc.)',
  DISCONTINUE_DATE = 'Discontinue Date',
  DISCONTINUE_TIME = 'Discontinue Time',
  DISCONTINUE_TIME_OFFSET = 'Discontinue Time Offset',
  DISCONTINUE_COMMENTS = 'Comments (Reason for discontinue, Notes, etc.)',
  INITIALS = 'Initials'
}

export const DOSE_MODE = {
  ADMINISTER: 'ADMINISTER',
  HOLD: 'HOLD',
  DISCONTINUE: 'DISCONTINUE'
};

export const HOLD_UNHOLD_MODE = {
  HOLD: 'HOLD',
  UNHOLD: 'UNHOLD'
};

export const INACTIVE_TYPE = {
  COMPLETED: 'Completed',
  DISCONTINUED: 'Discontinued',
  PAST_DUE: 'Past due',
  EXPIRED: 'Expired',
  STAT_ADMINISTERED: 'Stat! Administered'
};

export const INACTIVE_ORDERS_SHOW_DOSAGE_TIMES_COUNT = 500;
export const EXPIRED_DAYS = 8;
export const AUTHOR_MAR_DAYS = 7;

export const ORDER_TYPES = {
  PRN: 'PRN',
  STAT: 'Stat!',
  IV: 'Routine'
};

export const SPECIAL_DOSAGE_MAPPING_RULES = {
  NORMAL: 0,
  AFTER_START_TIME: 1,
  AFTER_FIRST_DOSE: 2,
  TIMES_IN_A_WEEK: 3,
  ONCE_THEN_DROP_OFF: 4
};

export const PATIENT_ID_MESSAGE = 'Start by scanning the patient’s ID. Then scan the medication barcode(s) to administer the medication(s).';

export const FORM_FIELD_DEFAULT_VALUE = {
  error: '',
  value: '',
  isRequired: true,
  isTouched: false,
  skipBarCode: false,
  type: 'text',
  administrationTime: {
    value: '00:00',
    label: 'Administration Time',
    isRequired: true,
    error: '',
    isTouched: false,
    type: 'time'
  },
  initials: {
    value: '',
    label: 'Initials',
    isRequired: true,
    error: '',
    isTouched: false,
    type: 'text'
  },
  comment: {
    value: '',
    label: 'Comments',
    isRequired: false,
    error: '',
    isTouched: false,
    type: 'area'
  },
  edit: false,
  addedMedication: false,
  medicationChanged: false
};

export const TIME_OFFSET_REGEX = /^\d+:(0[0-9]|[1-5][0-9])$/;
